import { RefObject, useEffect } from 'react';

export interface KeyboardNavigationProps {
  listRef: RefObject<HTMLElement>;
  listFetchComplete: boolean;
}

export function useKeyboardNavigation({
  listRef,
  listFetchComplete
}: KeyboardNavigationProps) {

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!listRef.current || !listFetchComplete) {
        return;
      }

      const _items = Array.from(
        listRef.current.querySelectorAll<HTMLElement>(
          '.keyboard-nav-item:not([aria-disabled="true"]):not([disabled])'
        )
      );

      const currentIndex = _items.indexOf(document.activeElement as HTMLElement) || 0;
      let nextIndex = currentIndex;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        nextIndex = (currentIndex + 1) % _items.length;
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        nextIndex = (currentIndex - 1 + _items.length) % _items.length;
      }

      const nextElement = _items[nextIndex];

      nextElement?.focus();
      nextElement?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [listRef, listFetchComplete]);
}
